/**
* shorthash
* (c) 2013 Bibig
*
* https://github.com/bibig/node-shorthash
* shorthash may be freely distributed under the MIT license.
*/

/*
* adapted so it can be used with module imports by Felix @2018
*/


// refer to: http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
const bitwise = (str) => {
    let hash = 0;

    if (str.length === 0) return hash;

    for (let i = 0; i < str.length; i += 1) {
        const ch = str.charCodeAt(i);

        /* eslint-disable no-bitwise */
        hash = ((hash << 5) - hash) + ch;

        hash &= hash; // Convert to 32bit integer
        /* eslint-enable no-bitwise */
    }

    return hash;
};

// Convert a base-10 number to a numeral system of any base up to 62
const binaryTransfer = (_integer, _binary) => {
    const binary = _binary || 62;

    const stack = [];
    let num;
    let result = '';
    let integer = Math.abs(_integer);
    const sign = _integer < 0 ? '-' : '';

    function table(_num) {
        const t = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

        return t[_num];
    }

    while (integer >= binary) {
        num = integer % binary;

        integer = Math.floor(integer / binary);

        stack.push(table(num));
    }

    if (integer > 0) {
        stack.push(table(integer));
    }

    for (let i = stack.length - 1; i >= 0; i -= 1) {
        result += stack[i];
    }

    return sign + result;
};


/**
 * why choose 61 binary, because we need the last element char to replace the minus sign
 * eg: -aGtzd will be ZaGtzd
 */
export default (text) => {
    // added a check for string input
    if (typeof text !== 'string') {
        return Error('shorthand needs a string as input. Use stringify if necessary.');
    }

    return binaryTransfer(bitwise(text), 61).replace('-', 'Z');
};
